module.exports = __webpack_public_path__ + "static/media/contact-leaf.712092c9.svg";